import React, { Component } from "react";
import classNames from "classnames";
import { sendAPIRequest } from "shared/utils/requests";
import { MdClose as XMark } from "@react-icons/all-files/md/MdClose";
import { MdInfo } from "@react-icons/all-files/md/MdInfo";
import { Icon } from "../base-components";

class InviteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inviteEmail: "",
      inviteStatusMessage: "",
      isInviteSuccess: false,
    };
  }

  handleInviteManagerSubmit = async () => {
    const { inviteEmail } = this.state;
    const payload = { email: inviteEmail };

    sendAPIRequest("/users/invite_manager", "POST", payload)
      .then(() => {
        this.setState({ isInviteSuccess: true });
      })
      .catch((err) => {
        const responseMessage =
          err.response.data.message || "Something went wrong";
        this.setState({ inviteStatusMessage: responseMessage });
      });
  };

  handleInviteManagerInput = (e) => {
    this.setState({
      inviteEmail: e.target.value,
    });
  };

  renderModal = () => {
    const { hideInviteModal } = this.props;
    const { inviteEmail, inviteStatusMessage } = this.state;

    const emailFormStyle = classNames("invite-modal-form-email", {
      "invite-modal-form-email-active": inviteStatusMessage.length > 0,
    });

    return (
      <div className="modal-overlay" onClick={hideInviteModal}>
        <div className="invite-modal" onClick={(e) => e.stopPropagation()}>
          <div className="flex-row invite-modal-exit-container">
            <span className="invite-modal-exit" onClick={hideInviteModal}>
              <XMark size={23} />
            </span>
          </div>
          <div className="invite-modal-content">
            <div className="flex-row invite-modal-title">
              Invite User to QA-World
            </div>
            <div className="flex-row invite-modal-banner">
              <div className="invite-modal-icon">
                <MdInfo size={17} />
              </div>
              <div>
                <div className="invite-modal-message">
                  The user will be invited to apply for QA World.
                </div>
              </div>
            </div>
            <div className="invite-modal-form">
              <div className="invite-modal-form-title">
                NEW USER&apos;S EMAIL
              </div>
              <div className="flex-row invite-modal-form-content">
                <textarea
                  className={emailFormStyle}
                  value={inviteEmail}
                  onChange={this.handleInviteManagerInput}
                  placeholder="email@company.com"
                />
                <div
                  className="flex-fixed invite-modal-form-submit"
                  onClick={this.handleInviteManagerSubmit}
                >
                  Invite User
                </div>
              </div>
              <div className="invite-modal-form-status">
                {inviteStatusMessage}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderInviteSuccess = () => {
    const { hideInviteModal } = this.props;
    const { inviteEmail } = this.state;

    return (
      <div className="modal-overlay" onClick={hideInviteModal}>
        <div className="invite-modal">
          <div className="flex-row invite-modal-exit-container">
            <span className="invite-modal-exit" onClick={hideInviteModal}>
              <XMark size={23} />
            </span>
          </div>
          <div className="invite-modal-content">
            <div className="flex-row modal-success-icon">
              <Icon filename="check" size={25} />
            </div>
            <div className="flex-row modal-success-title">
              New Manager Added!
            </div>
            <div className="flex-row modal-success-subtitle">
              We send an onboarding email to
            </div>
            <div className="flex-row modal-success-email">{inviteEmail}</div>
            <div className="flex-row modal-success-close-container">
              <div className="modal-success-close" onClick={hideInviteModal}>
                Close
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { isInviteSuccess } = this.state;
    if (isInviteSuccess) {
      return this.renderInviteSuccess();
    } else {
      return this.renderModal();
    }
  }
}

export default InviteModal;
